import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { UserTaskHistory } from './user-task-history';
export { UserTaskHistory };
import { userTaskHistorySchema } from '@schemas/business-objects/user-task-history';
import { TenantFormGroup } from './tenant-form-group';
import { UserTaskFormGroup } from './user-task-form-group';

export class UserTaskHistoryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    eventType: SchemaFormControl;
    data: SchemaFormControl;
    timestamp: SchemaFormControl;
    userTaskId: SchemaFormControl;
    userTask: UserTaskFormGroup;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<UserTaskHistory>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(userTaskHistorySchema, UserTaskHistory, data, options);
  }

  get object(): UserTaskHistory {
    return new UserTaskHistory(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'userTask':
        return new UserTaskFormGroup();
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<UserTaskHistory[]> {
    return UserTaskHistory.find(filter);
  }

  static async findOne(filter?: any): Promise<UserTaskHistory | null> {
    return UserTaskHistory.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<UserTaskHistory> {
    return UserTaskHistory.findById(id, filter);
  }

  static async create(
    data: Partial<UserTaskHistory>,
  ): Promise<UserTaskHistory> {
    return UserTaskHistory.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<UserTaskHistory>,
  ): Promise<UserTaskHistory> {
    return UserTaskHistory.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return UserTaskHistory.deleteById(id);
  }
}

export class UserTaskHistoryFormArray extends PersistedFormArray {
  declare controls: UserTaskHistoryFormGroup[];

  readonly entityName = 'UserTaskHistory' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(userTaskHistorySchema, UserTaskHistory, options);
  }

  protected override createItemGroup() {
    return new UserTaskHistoryFormGroup();
  }

  get array(): UserTaskHistory[] {
    return this.controls.map((group: UserTaskHistoryFormGroup) => group.object);
  }
}

export class UserTaskHistoryPersistedArray extends PersistedArray<UserTaskHistory> {
  readonly entityName = 'UserTaskHistory' as const;

  constructor(options?: PersistedArrayOptions) {
    super(UserTaskHistory, options);
  }
}
